// src/pages/Home/components/sections/AppSection.jsx
import React from "react";

import googlePlayLogo from "../../../assets/images/google-play.png";
import appStoreLogo from "../../../assets/images/app-store.png";
import webLogoLight from "../../../assets/images/logoD2.png";
import webLogoDark from "../../../assets/images/logoD.png";

export default function AppSection({ t, lang, theme, onDownload }) {
  return (
    <section className="aq-section aq-section-alt" id="app">
      <div className="aq-container">
        <div className="aq-app-center">
          <h2>{t("app.title")}</h2>
          <p className="aq-muted">{t("app.desc")}</p>

          <div className="aq-app-actions">
            <a
              className="aq-app-btn aq-app-btn--gp"
              href="#"
              onClick={(e) => (e.preventDefault(), onDownload())}
              aria-label={
                lang === "ar"
                  ? "تحميل من جوجل بلاي"
                  : "Download from Google Play"
              }
            >
              <img
                className="aq-app-btn-ico"
                src={googlePlayLogo}
                alt="Google Play"
              />
              <span className="aq-app-btn-text">
                {lang === "ar"
                  ? "حمّل تطبيق أمانكو من خلال Google Play"
                  : "Download Aman-QO from Google Play"}
              </span>
            </a>

            <a
              className="aq-app-btn aq-app-btn--ios"
              href="#"
              onClick={(e) => (e.preventDefault(), onDownload())}
              aria-label={
                lang === "ar" ? "تحميل من آب ستور" : "Download from App Store"
              }
            >
              <img
                className="aq-app-btn-ico"
                src={appStoreLogo}
                alt="App Store"
              />
              <span className="aq-app-btn-text">
                {lang === "ar"
                  ? "حمّل تطبيق أمانكو من خلال App Store"
                  : "Download Aman-QO from the App Store"}
              </span>
            </a>

            <a
              className="aq-app-btn aq-app-btn--web"
              href="#"
              onClick={(e) => (e.preventDefault(), onDownload())}
              aria-label={
                lang === "ar"
                  ? "تحميل مباشر من الموقع"
                  : "Direct website download"
              }
            >
              <img
                className="aq-app-btn-ico"
                src={theme === "light" ? webLogoLight : webLogoDark}
                alt="Aman-QO Website"
              />
              <span className="aq-app-btn-text aq-app-btn-text--bold">
                {lang === "ar"
                  ? "تحميل مباشر لتطبيق أمانكو من موقع Aman-Qo"
                  : "Direct download of Aman-QO from Aman-Qo website"}
              </span>
            </a>
          </div>
          <a
            className="aq-btn aq-btn-solid aq-btn-download aq-app-btn--pre"
            href="https://docs.google.com/forms/d/e/1FAIpQLSfipFzR5_vkv-C0sZ3X6bzbRi0E0QiWLtMhuyIm5MG1ykMpeA/viewform"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={lang === "ar" ? "التسجيل المسبق" : "Pre-registration"}
          >
            <span className="aq-app-btn-text aq-app-btn-text--bold">
              {lang === "ar" ? "التسجيل المسبق" : "Pre-registration"}
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
